export default "<div id=\"div_fdic_standard_header\" style=\"display: initial\"></div>\r\n";